import { BrowserRouter as Router, Routes, Route, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './index.css'; // Import the CSS file for styling
import Configurator from './components/Configurator';
import OrderDetails from './components/OrderDetails';
import { setLang, t } from './utils/i18n';

// Component to pass parameters to Configurator
function ConfiguratorWithParam() {
  const [searchParams] = useSearchParams();
  const productId = searchParams.get('product_id');
  const cartId = searchParams.get('cart_id');
  const draftId = searchParams.get('draft_id');
  const webhookUrl = searchParams.get('webhook_url');

  // Allow the configurator to run with product_id alone (fetches from new API)
  // Also supports: product_id + cart_id, draft_id, or webhook_url
  if (!productId && !draftId && !webhookUrl) {
    return <div>{t('Error: Invalid parameters. Required: product_id, or draft_id, or webhook_url')}</div>;
  }

  return <Configurator product_id={productId} cart_id={cartId} draft_id={draftId} />;
}

function LanguageSelector() {
  return (
    <div style={{ position: 'fixed', top: 8, right: 8, zIndex: 1000, fontSize: 12 }}>
      <button
        style={{ margin: 2, padding: '2px 6px', borderRadius: 4, border: '1px solid #ccc', background: '#fff', cursor: 'pointer', opacity: 0.7 }}
        onClick={() => { setLang('en'); window.location.reload(); }}
        aria-label="Switch to English"
      >EN</button>
      <button
        style={{ margin: 2, padding: '2px 6px', borderRadius: 4, border: '1px solid #ccc', background: '#fff', cursor: 'pointer', opacity: 0.7 }}
        onClick={() => { setLang('nl'); window.location.reload(); }}
        aria-label="Switch to Dutch"
      >NL</button>
    </div>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Set a timer to remove the loading state after 2 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    // Cleanup the timer on component unmount
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <div className="preloader">{t('Loading...')}</div>; // Replace with your preloader design
  }

  return (
    <>
      <LanguageSelector />
      <Router>
        <Routes>
          <Route path="/" element={<ConfiguratorWithParam />} />
          <Route path="/order-details" element={<OrderDetails />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
